// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__1AZP6","productName":"Table_productName__2HQQE"};